import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Spettacolo, Stagione } from '../../../shared/interface';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { StorageService } from '../../../services/storage.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-spettacoli-backoffice',
  templateUrl: './spettacoli-backoffice.component.html',
  styleUrl: './spettacoli-backoffice.component.css',
  encapsulation: ViewEncapsulation.None
})
export class SpettacoliBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private storageService: StorageService, private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef) { }

  @ViewChild("deleteSpettacolo") deleteSpettacolo!: ConfirmPopup;
  @ViewChild("table") table!: Table;

  spettacoli: Spettacolo[] = []
  spettacoli_filterd: Spettacolo[] = []
  configurazione?: Stagione;

  stagione: string[] = [];

  loading: boolean = false;

  pagina: number = 0;

  ngOnInit(): void {

    this.stagione = ['stagione']
    this.loading = true;

    this.apiService.getStagione().subscribe({
      next: (data) => this.configurazione = data,
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        this.apiService.setSpettacoli();
        this.apiService.spettacoliChanged.subscribe({
          next: (data) => {
            this.loading = true;
            this.spettacoli = [...data];
    
            if (this.stagione.length > 0) {              
              this.spettacoli_filterd = [...this.spettacoli.filter(spettacolo => new Date(spettacolo.al) >= new Date(this.configurazione!.inizio_stagione) && new Date(spettacolo.al) <= new Date(this.configurazione!.fine_stagione))];
            } else {
              this.spettacoli_filterd = [...this.spettacoli];
            }
    
            this.spettacoli_filterd.map(spettacolo => {
              spettacolo.dal = new Date(<Date>spettacolo.dal)
              spettacolo.al = new Date(<Date>spettacolo.al)
            });
    
            let filtri: {pagina: number, spettacolo: string, dal: string, al: string} | null = this.storageService.getFiltriBackoffice();
            this.pagina = filtri?.pagina ? filtri.pagina : 0;

            let table_filters: any = this.table.filters;            
            table_filters.spettacolo.value = filtri?.spettacolo ? filtri.spettacolo : table_filters.spettacolo.value;
            table_filters.dal.value = filtri?.dal ? new Date(filtri.dal) : table_filters.dal.value;
            table_filters.al.value = filtri?.al ? new Date(filtri.al) : table_filters.al.value;
            
            this.loading = false;
    
          },
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
        })
      }
    })

  }

  calculateDateDiff(dal: Date, al: Date) {
    let date_dal = new Date(dal);
    let date_al = new Date(al);
    return Math.floor((Date.UTC(date_al.getFullYear(), date_al.getMonth(), date_al.getDate()) - Date.UTC(date_dal.getFullYear(), date_dal.getMonth(), date_dal.getDate())) / (1000 * 60 * 60 * 24));
  }

  onOpenDeleteSpettacolo(event: Event, spettacolo: Spettacolo) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare lo spettacolo?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteSpettacolo(spettacolo.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.setSpettacoli()
            this.apiService.message("success", "Eliminazione", "Lo spettacolo è stato eliminato con successo!")
          }
        })
      }
    });
  }

  onDeleteSpettacolo() {
    this.deleteSpettacolo.accept();
  }

  onAnnullaDeleteSpettacolo() {
    this.deleteSpettacolo.reject();
  }

  onStagione(stagione: string[]) {
    this.apiService.setSpettacoli();
    this.cdr.detectChanges();
  }

  onPageChange(event: any, element: HTMLElement) {
    let table_filter: any = this.table.filters;
    this.storageService.setFiltriBackoffice({ pagina: event.first, spettacolo: table_filter.spettacolo.value, dal: table_filter.dal.value, al: table_filter.al.value })
    element.scrollIntoView({ behavior: 'smooth' });
  }

  onFiltro(event: any) {
    this.storageService.setFiltriBackoffice({ pagina: this.pagina, spettacolo: event.filters.spettacolo.value, dal: event.filters.dal.value, al: event.filters.al.value })
    if (!event.filters.spettacolo.value && !event.filters.dal.value && !event.filters.al.value)
      this.table.first = this.pagina;
  }

}
